.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  max-width: 400px;
  padding: 20px;
  margin: 0 auto;
  background-color: #ffffff;
  transition: all 0.3s ease;
  --slide-distance: -25%;
  --transition-duration: 0.5s;
  composes: slideDown from global;
}
.container:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 1);
  transform: scale(1.04);
}

.actionTitle {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.actionDetails {
  margin-bottom: 20px;
  font-size: 14px;
}

.actionDetailItem {
  margin-bottom: 10px;
}

.buttons {
  display: flex;
  gap: 10px;
}
